import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Auth from "@/store/modules/auth.js";
import Login from "@/store/modules/login.js";
import Mypage from "@/store/modules/mypage.js";
import Pass from "@/store/modules/pass.js";
import Account from "@/store/modules/account.js";
import Register from "@/store/modules/register.js";
import TransferCertify from "@/store/modules/transferCertify.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    Login,
    Mypage,
    Pass,
    Account,
    Register,
    TransferCertify
  },
  plugins: [
    createPersistedState({
      paths: ["Account", "Auth", "TransferCertify"],
      storage: window.sessionStorage
    }),
    createPersistedState({
      paths: ["Pass", "Mypage", "Register"],
      storage: window.localStorage
    })
  ]
});
